/* eslint-disable @typescript-eslint/no-explicit-any */
import { HalfStar, Star } from "@/components/icons";
import { TROPHY_CLUB_GOOGLE_REVIEWS_URL } from "@/lib/constants";
import Image from "next/image";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import Link from "next/link";
import { getInitials } from "@/lib/utils";

const TestimonialCard = ({ data }: any) => {
  const rating = data?.rating || 0; // Default to 0 if no rating
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  return (
    <div className="flex flex-row gap-x-28">
      <Image
        src="/icons/quote.png"
        alt="quote"
        width={120}
        height={120}
        className="hidden size-28 shrink-0 object-contain object-center lg:block"
      />
      <div className="flex flex-col gap-y-6 lg:gap-y-12">
        <div className="flex items-center">
          {/* Render full stars */}
          {[...Array(fullStars)].map((_, index) => (
            <Star
              key={`full-${index}`}
              className="size-7 text-[#FFBB00] lg:size-12"
            />
          ))}

          {/* Render half star if needed */}
          {hasHalfStar && (
            <HalfStar key="half" className="size-7 text-[#FFBB00] lg:size-12" />
          )}
          {/* Render empty stars */}
          {[...Array(emptyStars)].map((_, index) => (
            <Star
              key={`empty-${index}`}
              className="size-7 text-gray-300 lg:size-12"
            />
          ))}

          <Link
            href={TROPHY_CLUB_GOOGLE_REVIEWS_URL}
            target="_blank"
            className="ml-3 text-xl font-bold text-blue-600 underline underline-offset-8 lg:text-5xl"
          >
            (3k+)
          </Link>
        </div>
        <p className="text-primary text-2xl font-medium lg:text-5xl">
          {data?.review}
        </p>
        <div className="flex items-center gap-x-4">
          <Avatar className="size-16 shrink-0 lg:size-20">
            <AvatarImage
              src={data?.user_avatar}
              alt={data?.user_name || "User Avatar"}
              className="object-contain"
            />
            <AvatarFallback className="bg-slate-100 text-xl text-slate-700 lg:text-3xl">
              {getInitials(data?.user_name)}
            </AvatarFallback>
          </Avatar>

          <div className="flex flex-col gap-y-1 lg:gap-y-2">
            <h3 className="text-xl font-semibold text-slate-800 capitalize lg:text-3xl">
              {data?.user_name}
            </h3>
            <p className="text-base font-medium text-slate-800 lg:text-2xl">
              {data?.user_designation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
